/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, {
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import "../../../assets/styles/custom-style.css";
import { useNavigate } from "react-router-dom";
import { UUID } from "crypto";
import ListDishes from "./ListDishes";
import { useAuth } from "../../../auth";
import Select from "react-select";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getCategory,
  getCuisine,
  getType,
  DishCreate,
  getIngredient,
  checkDuplicateDish,
  getMeasurement,
  getDishAddons,
  getAddonsType,
} from "../core/_requests";
// @ts-ignore
import AvatarEditor from "react-avatar-editor";
import { ProfileDetails } from "../../settings/core/_requests";
import { dishSchema } from "../core/Schema";
import AddIngredient from "../../incrediants/files/AddIngredient";
import CloseButton from "../../../component/core/Buttons";
interface Cuisine {
  uuid: UUID;
  name: string;
}
interface Type {
  uuid: UUID;
  name: string;
}
interface Category {
  uuid: UUID;
  name: string;
}
interface Ingredient {
  id: string;
  name: string;
}
interface Measurement {
  id: string;
  name: string;
  measurementName: string;
  dishOrderType: number;
}
interface AddonsType {
  uuid: UUID;
  typeName: string;
  description: string;
  enableDisableStatus: boolean;
}
interface DishAddons {
  uuid: UUID;
  addonsName: string;
  amount: number;
  enableDisableStatus: boolean;
  type: any;
}
interface DishAdd {
  chefId: any;
  name: string;
  categoryId: string;
  typeId: string;
  cuisineId: string;
  description: string;
  specialInstruction: string;
  ingredients: string;
  dishType: any;
  preparationTime: string;
  dishImage: any;
  formImage: any;
  tags: string;
  createdBy: any;
  dishvariants: [
    {
      unit: any;
      measurementId: number;
      price: any;
      discount: number;
      finalPrice: any;
    }
  ];

  dishAddons: [
    {
      addonsTypeId: string;
      addonsId: string;
      createdBy: number;
    }
  ];
}

const initialValues: DishAdd = {
  chefId: "",
  name: "",
  categoryId: "",
  typeId: "",
  cuisineId: "",
  description: "",
  specialInstruction: "",
  ingredients: "",
  preparationTime: "",
  dishType: 1,
  dishImage: "",
  formImage: "",
  tags: "",
  createdBy: "",
  dishvariants: [
    {
      unit: 1,
      measurementId: 2,
      price: "",
      discount: 0,
      finalPrice: "",
    },
  ],
  dishAddons: [
    {
      addonsTypeId: "",
      addonsId: "",
      createdBy: 0,
    },
  ],
};

const AddDish = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [formImage, setFormImage] = useState<File | null>(null);
  const [data, setData] = useState<DishAdd>(initialValues);
  const [loading, setLoading] = useState(false);
  const [cuisine, setCuisine] = useState<Cuisine[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  const [ingredient, setIngredient] = useState<Ingredient[]>([]);
  const [type, setType] = useState<Type[]>([]);
  const [selectedType, setSelectedType] = useState("");
  const [activeType, setActiveType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showIngredient, setShowIngredient] = useState(false);
  const [editImage, setEditImage] = useState(false);
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [editWidth, setEditWidth] = useState(250); // Initial width value
  const [editHeight, setEditHeight] = useState(250); // Initial height value
  const editorRef = useRef<AvatarEditor>(null);
  const [Duplicate, setDuplicate] = useState("");
  const [dishTypevalues, setDishType] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [addonsType, setAddonsType] = useState<AddonsType[]>([]);
  const [dishAddons, setDishAddons] = useState<DishAddons[]>([]);
  const [hasBulkDishAccess, setHasBulkDishAccess] = useState(false);
const [bulkDishCount, setBulkDishCount] = useState(0);
const [isBulkLoading, setIsBulkLoading] = useState(true);

  const chefId = currentUser?.uuid;
  const [selectedAddons, setSelectedAddons] = useState<{
    [key: string]: string[];
  }>({});

    const [measurement, setMeasurement] = useState<Measurement[]>([]);
  const [filteredMeasurements, setFilteredMeasurements] = useState<
    Measurement[]
  >([]);
  const [selectedMeasurementName, setSelectedMeasurementName] =
    useState<string>("");
  const [bulk_dish_count, setIsBulkDish] = useState<any>();

useEffect(() => {
  ProfileDetails(chefId).then((res) => {
    const access =
      res.data?.chef_plan_subscriptions?.[0]?.plan?.chef_plan_accesses?.[0];

    if (access) {
      setHasBulkDishAccess(access.is_bulk_dish === true);
      setBulkDishCount(access.dish_count ?? 0);
    }
     setIsBulkLoading(false); 
  });
}, [chefId]);

  const handleCheckboxChangeDishaddon = (
    addonType: string,
    addonId: string
  ) => {
    setSelectedAddons((prevState) => {
      const currentAddons = prevState[addonType] || [];
      if (currentAddons.includes(addonId)) {
        return {
          ...prevState,
          [addonType]: currentAddons.filter((id) => id !== addonId),
        };
      } else {
        return {
          ...prevState,
          [addonType]: [...currentAddons, addonId],
        };
      }
    });
  };
  useEffect(() => {
    const dishAddonsArray = Object.keys(selectedAddons).flatMap((addonType) => {
      return selectedAddons[addonType].map((addonId) => ({
        addonsTypeId: addonType,
        addonsId: addonId,
      }));
    });

    formik.setFieldValue("dishAddons", dishAddonsArray);
  }, [selectedAddons]);

  const inputs = useRef<Array<HTMLInputElement | HTMLSelectElement | null>>([]);

  const [selectedCategory, setSelectedCategory] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [selectedCuisine, setSelectedCuisine] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const toggleEditImage = () => {
    setEditImage(!editImage);
  };

  const handleImageEdit = () => {
    if (editorRef.current) {
      const canvas = (editorRef.current as any).getImageScaledToCanvas();
      canvas.toBlob((blob: Blob | null) => {
        if (blob) {
          const reader = new FileReader();
          reader.onload = () => {
            if (reader.readyState === 2) {
              setData({
                ...data,
                dishImage: reader.result,
              });
            }
          };
          reader.readAsDataURL(blob);
        }
      });
    }
    setEditImage(false); // Close the edit image section after saving
  };
  const handlePriceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newPrice = e.target.value;
    const currentVariant = formik.values.dishvariants[index];
    if (currentVariant) {
      const newFinalPrice = parseFloat(newPrice) - currentVariant.discount;
      formik.setFieldValue(`dishvariants[${index}].price`, newPrice);
      formik.setFieldValue(`dishvariants[${index}].finalPrice`, newFinalPrice);
    }
  };

  const handleDiscountChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newDiscount = e.target.value;
    const currentVariant = formik.values.dishvariants[index];
    const newFinalPrice = currentVariant.price - parseFloat(newDiscount);
    formik.setFieldValue(`dishvariants[${index}].discount`, newDiscount);
    formik.setFieldValue(`dishvariants[${index}].finalPrice`, newFinalPrice);
  };
  const handleRemoveStrength = (indexToRemove: any) => {
    const updatedtags = formik.values.tags
      .split(",")
      .filter((_, index) => index !== indexToRemove)
      .join(",");
    formik.setFieldValue("tags", updatedtags);
  };


  // Add a function to handle changes in the textarea
  const handleTagInputChange = (inputValue: any) => {
    formik.setFieldValue("tags", inputValue);
  };
  const [dishvariants, setdishvariants] = useState([
    { unit: 0, measurementId: 0, price: 0, discount: 0, finalPrice: 0 },
  ]);
  const addDishPriceRow = () => {
    const newRow = {
      unit: 1,
      measurementId: 2,
      price: 0,
      discount: 0,
      finalPrice: 0,
    };
    setdishvariants((dishvariants: any) => [...dishvariants, newRow]);
    // Update Formik field value along with local state update
    formik.setFieldValue("dishvariants", [
      ...formik.values.dishvariants,
      newRow,
    ]);
  };
  const DishPricRemove = (i: number) => {
    const newForm = [...dishvariants];
    newForm.splice(i, 1);
    setdishvariants(newForm);
  };

  useEffect(() => {
    // Fetch cuisines and types
    getCuisine()
      .then((res) => {
        setCuisine(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching cuisines:", error);
      });

    getType()
      .then((res) => {
        setType(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching types:", error);
      });
    getMeasurement()
      .then((res) => {
    
        setMeasurement(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching types:", error);
      });
  }, []);

  useEffect(() => {
    getCategory(!chefId)
      .then((res) => {
        setCategory(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    listIngredent();
  }, []);
  const listIngredent = () => {
    getIngredient(!chefId)
      .then((res) => {
        setIngredient(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching ingredients:", error);
      });
  };
  useEffect(() => {
    // Fetch cuisines and types
    getAddonsType(chefId)
      .then((res) => {
                        setAddonsType(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching cuisines:", error);
      });
    getDishAddons(chefId)
      .then((res) => {
                        setDishAddons(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching cuisines:", error);
      });
  }, []);
  const clickCancel = () => {
    navigate("/dish");
  };
  const compressImage = async (file: File) => {
    return new Promise<Blob>((resolve) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const maxWidth = 800; // Max width for compressed image
        const maxHeight = 600; // Max height for compressed image
        let width = image.width;
        let height = image.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(image, 0, 0, width, height);
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(blob);
              }
            },
            file.type,
            0.7
          ); // Adjust the compression quality here (0.7 means 70% quality)
        }
      };
    });
  };

  const imageHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader();
    const files = e.target.files;

    if (files && files[0]) {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ];
      const maxFileSize = 1024 * 1024; // 1MB
      const maxAllowedSize = 500 * 1024; // 500KB

      if (!allowedTypes.includes(files[0].type)) {
        setErrorMessage(
          "Invalid file type. Allowed types are JPEG, PNG, JPG, and WEBP."
        );
        setFormImage(null);
        return;
      } else if (files && files[0].size > 1024 * 1024) {
        // Check if file size exceeds 1MB
        setErrorMessage("File size should be less than 1MB.");
        setFormImage(null);
      }
      if (files[0].size > maxFileSize) {
        const compressedImage = await compressImage(files[0]);
        const compressedFile = new File([compressedImage], files[0].name, {
          type: files[0].type,
          lastModified: Date.now(),
        });

        reader.onload = () => {
          if (reader.readyState === 2) {
            setData({
              ...data,
              dishImage: reader.result,
            });
          }
        };

        setFormImage(compressedFile);
        reader.readAsDataURL(compressedFile);
      } else {
        setErrorMessage("");
        reader.onload = () => {
          if (reader.readyState === 2) {
            setData({
              ...data,
              dishImage: reader.result,
            });
          }
        };

        setFormImage(files[0]);
        reader.readAsDataURL(files[0]);
      }
    }
  };

 const handleErrorMessageClose = () => {
  setErrorMessage("");

  // ❗ Always close editor explicitly
  setEditImage(false);

  // Remove image
  setFormImage(null);
  setData((prev) => ({
    ...prev,
    dishImage: null,
  }));

  // Reset file input
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};


  const modalIngredient = () => {
    setShowIngredient(!showIngredient);
    listIngredent();
  };
  const [preparationTimeValue, setPreparationTimeValue] = useState("");
  const [preparationTypeValue, setPreparationTypeValue] = useState("Mins");

  
  const handlePreparationTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const timeValue = e.target.value;
    setPreparationTimeValue(timeValue);

    // Concatenate time and type
    formik.setFieldValue(
      "preparationTime",
      `${timeValue} ${preparationTypeValue}`
    );
  };

  const handlePreparationTypeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedType = e.target.value;
    setPreparationTypeValue(selectedType);

    // Concatenate time and type
    formik.setFieldValue(
      "preparationTime",
      `${preparationTimeValue} ${selectedType}`
    );
  };
  // Capitalize each word in a string
const capitalizeWords = (str: string) => {
  return str
    .split(" ")
    .filter(Boolean) // remove extra spaces
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

  const formik = useFormik<DishAdd>({
    initialValues,
    validationSchema: dishSchema,
    onSubmit: async (values, { resetForm }) => {
       if (Duplicate) {
    // setErrorMessage("Dish name already exist");
    return; // Stop submission
  }
      values.chefId = chefId;
      values.createdBy = currentUser?.chefId;
        values.name = capitalizeWords(values.name);
      const updatedData = Object.assign(data, values);
            const formData = new FormData();
      if (formImage) formData.append("dishImage", formImage);
      formData.append("name", values.name);
      formData.append("categoryId", values.categoryId);
      formData.append("chefId", values.chefId);
      formData.append("typeId", values.typeId);
      formData.append("cuisineId", values.cuisineId);
      formData.append("description", values.description);
      formData.append("specialInstruction", values.specialInstruction);
      formData.append("ingredients", values.ingredients);
      formData.append("tags", values.tags);
      formData.append("dishType", values.dishType);
      formData.append("preparationTime", values.preparationTime);

      formData.append("createdBy", values.createdBy);
      values.dishvariants.forEach((dishvariants, index) => {
        formData.append(
          `dishvariants[${index}][unit]`,
          String(dishvariants.unit)
        );
        formData.append(
          `dishvariants[${index}][measurementId]`,
          String(dishvariants.measurementId)
        );
        formData.append(
          `dishvariants[${index}][price]`,
          String(dishvariants.price)
        );
        formData.append(
          `dishvariants[${index}][discount]`,
          String(dishvariants.discount)
        );
        formData.append(
          `dishvariants[${index}][finalPrice]`,
          String(dishvariants.finalPrice)
        );
      });

      values.dishAddons.forEach((dishAddons, index) => {
        formData.append(
          `dishAddons[${index}][addonsTypeId]`,
          dishAddons.addonsTypeId
        );
        formData.append(`dishAddons[${index}][addonsId]`, dishAddons.addonsId);
        formData.append(`dishAddons[${index}][createdBy]`, values.createdBy);
      });
      setLoading(true);
      DishCreate(formData)
        .then((res) => {
                    if (res?.status === true) {
            navigate("/dish/success", { replace: true });
            setLoading(false);
          } else {
            setLoading(false);
            setErrorMessage(res?.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          // setErrorMessage("Something Went Wrong");
        });
      resetForm();
    },
  });
 

  useEffect(() => {
    // On initial load, if dishType is set to 1, set the corresponding measurementId
    
  

    handleDishTypeChange(formik.values.dishType);
  }, [formik.values.dishType, measurement]); // Empty dependency array to run only on component mount

  const handleMeasurementChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const selectedMeasurementId = e.target.value; // Assuming IDs are strings
    const selectedMeasurement = filteredMeasurements.find((item) => {
      return String(item.id).trim() === selectedMeasurementId.trim();
    });

    if (selectedMeasurement) {
      setSelectedMeasurementName(selectedMeasurement.measurementName);
    } else {
      setSelectedMeasurementName("Unit");
    }

    formik.setFieldValue(
      `dishvariants[${index}].measurementId`,
      selectedMeasurementId
    );
  };
 const handleBulkClick = () => {
  if (isBulkLoading) return; 
  if (!hasBulkDishAccess) {
    navigate("/access");
    formik.setFieldValue("dishType", "1");
    return;
  }

  if (bulkDishCount <= 0) {
    navigate("/access");
    formik.setFieldValue("dishType", "1");
    return;
  }

  handleDishTypeChange("2"); // allow bulk
};

  // Auto filter measurement options based on dishType
  const handleDishTypeChange = (newDishType: string) => {
   
    // Set the dishType in Formik
    formik.setFieldValue("dishType", newDishType);

    // Filter measurements based on the dishType and update the state
    const newFilteredMeasurements = measurement.filter((item) => {
      return item.dishOrderType === parseInt(newDishType, 10);
    });

    setFilteredMeasurements(newFilteredMeasurements);

    // Auto select the first measurement from the filtered list (if any)
    if (newFilteredMeasurements.length > 0) {
      dishvariants.forEach((_, index) => {
        formik.setFieldValue(
          `dishvariants[${index}].measurementId`,
          newFilteredMeasurements[0].id
        );
      });
    }
  };

  useEffect(() => {
    checkDuplicateDish(chefId, formik.values.name).then((response) => {
      if (response?.isDuplicate === true) {
        setDuplicate("Dish name already exist");
      } else {
        setDuplicate("");
      }
    });
  }, [formik.values.name]);

  const handleWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditWidth(parseInt(e.target.value));
  };

  const handleHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditHeight(parseInt(e.target.value));
  };
  const dishOptions = [
    { label: "Regular", value: 1 }, // Default "Bulk" option
    { label: "Bulk", value: 2 }, // "Schedule" option
  ];

  // Get the initial value, which defaults to "Bulk"
  const defaultOption = dishOptions[0]; // Default value to "Bulk"

    return (
    <>
      <section className="container-fluid addContainerFluid">
        <ListDishes />
        <div className="overlay"></div>
        <div className="drawer small add-dish">
          <div className="title row">
            <h3 className="col-10 mb-0">Add New Dish</h3>
            <div className="col-2 text-end mb-md-2 mb-0">
              <button
                className="btn p-0 close d-inline-flex"
                onClick={clickCancel}
              >
                <i className="material-symbols-outlined">close</i>
              </button>
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            noValidate
            onKeyDown={(e: React.KeyboardEvent<HTMLFormElement>) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div className="col-12 mb-3 mt-3">
              <div className="row">
                <div className="col-3">
                  <div className="form-check">
                    <input
                      className={clsx(
                        "form-check-input me-3 radio-large",
                        {
                          "is-invalid":
                            formik.touched.dishType && formik.errors.dishType,
                        },
                        {
                          "is-valid":
                            formik.touched.dishType && !formik.errors.dishType,
                        }
                      )}
                      type="radio"
                      id="defaultOption"
                      name="dishType"
                      value="1"
                      checked={formik.values.dishType == "1"}
                      onChange={() => handleDishTypeChange("1")}
                    />
                    <label
                      className="form-check-label fs-bold"
                      htmlFor="defaultOption"
                    >
                      Regular
                    </label>
                  </div>
                </div>

                <div className="col-4">
                  <div className="form-check">
                    <input
                      className={clsx(
                        "form-check-input me-3 radio-large",
                        {
                          "is-invalid":
                            formik.touched.dishType && formik.errors.dishType,
                        },
                        {
                          "is-valid":
                            formik.touched.dishType && !formik.errors.dishType,
                        }
                      )}
                      type="radio"
  id="bulkOption"
  name="dishType"
  value="2"
  checked={formik.values.dishType == "2"}
  onChange={handleBulkClick}
                    // disabled={!bulk_dish_count} // Disable if bulk_dish_count is false
                    // value="2"
                    // checked={formik.values.dishType === "2"}
                    // onChange={() => handleDishTypeChange("2")}
                    />
                    <label
                      className="form-check-label fs-bold"
                      htmlFor="bulkOption"
                    >
                      Bulk
                    </label>
                  </div>
                </div>
              </div>

              {formik.touched.dishType && formik.errors.dishType && (
                <div className="fv-plugins-message-container">
                  <span role="alert">
                    {formik.errors.dishType as ReactNode}
                  </span>
                </div>
              )}
            </div>

            <div className="col-12 mb-3">
              <p className="mb-1 mid-gray">
                <span className="tiny">
                  We have a photo for your dish{" "}
                  <a href="#" className="text-link">
                    {" "}
                  </a>
                </span>
              </p>
              <div className="file-input">
                <input
                  type="file"
                  name="file"
                  id="file"
                  onChange={imageHandler}
                  ref={(el) => {
                    inputs.current[3] = el; // Assign to your array ref for handling Enter key press
                    fileInputRef.current = el; // Assign to your fileInputRef for handling file input operations
                  }}
                />

                <label htmlFor="file">
                  <i className="material-symbols-outlined">upload</i>
                  <span> Upload Dish Image </span>
                </label>
              </div>
              <span className="file-info">
                Supported file types (.jpg, .png, .jpeg) Max file size: 1MB
              </span>
              {data?.dishImage && (
                <>
                  <img
                    src={data?.dishImage}
                    height="100"
                    width="100"
                    alt="Uploaded Dish"
                  />
                 <button
  type="button"
  className="btn p-0 close d-inline-flex"
  onClick={() => setEditImage(true)}
>
  <i className="material-symbols-outlined fs-18">edit</i>
</button>

               <button
  type="button"
  className="btn p-0 close d-inline-flex"
  onClick={handleErrorMessageClose}
>
  <i className="material-symbols-outlined fs-18">close</i>
</button>

                </>
              )}
              {errorMessage && (
                <div style={{ color: "red" }} className="custom-error-messages">
                  {errorMessage}
                  <button
                    className="btn p-0 close d-inline-flex"
                    onClick={handleErrorMessageClose}
                  >
                    <i className="material-symbols-outlined fs-18">close</i>
                  </button>
                </div>
              )}
            </div>

            {/* Edit image section */}
            {editImage && (
              <div className="col-12">
                <AvatarEditor
                  ref={editorRef}
                  image={data?.dishImage}
                  width={editWidth}
                  height={editHeight}
                  border={50}
                  color={[255, 255, 255, 0.6]}
                  scale={scale}
                  rotate={rotation}
                />
                <div>
                  <button
                    className="btn btn-outline-primary rounded-5 me-2"
                    onClick={toggleEditImage}
                  >
                    Cancel Editing
                  </button>
                  <button
                    className="btn btn-outline-primary rounded-5"
                    onClick={handleImageEdit}
                  >
                    Save Image
                  </button>
                  <div className="col-12 mt-3">
                    <div className="row">
                      <div className="col-6">
                        <label htmlFor="width">Width:</label>
                        <input
                          id="width"
                          type="number"
                          className="form-control"
                          min="1"
                          value={editWidth}
                          onChange={handleWidthChange}
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="height">Height:</label>
                        <input
                          id="height"
                          className="form-control"
                          type="number"
                          min="1"
                          value={editHeight}
                          onChange={handleHeightChange}
                        />
                      </div>
                    </div>

                    <input
                      className="col-6 mt-3"
                      type="range"
                      min="1"
                      max="2"
                      step="0.01"
                      value={scale}
                      onChange={(e) => setScale(parseFloat(e.target.value))}
                    />
             
                  </div>
                </div>
              </div>
            )}

            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Dish Name
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.name && formik.errors.name,
                  },
                  {
                    "is-valid": formik.touched.name && !formik.errors.name,
                  }
                )}
                placeholder="Give a name to dish"
                ref={(el) => {
                  inputs.current[3] = el;
                }}
                {...formik.getFieldProps(`name`)}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="fv-plugins-message-container">
                  <span role="alert">{formik.errors.name}</span>
                </div>
              )}
              <span style={{ color: "red" }}>{Duplicate ? Duplicate : ""}</span>
            </div>

            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Cuisine
              </label>
              <Select
                className={clsx(
                  "",
                  {
                    "is-invalid":
                      formik.touched.cuisineId && formik.errors.cuisineId,
                  },
                  {
                    "is-valid":
                      formik.touched.cuisineId && !formik.errors.cuisineId,
                  }
                )}
                options={cuisine.map((item) => ({
                  label: item.name,
                  value: item.uuid,
                }))}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSelectedCuisine(selectedOption);
                    formik.setFieldValue("cuisineId", selectedOption.value);
                  }
                }}
                value={selectedCuisine}
                placeholder="Select cuisine"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "20px", // Change the border radius as needed
                  }),
                }}
              />
              {formik.touched.cuisineId && formik.errors.cuisineId && (
                <div className="fv-plugins-message-container">
                  <span role="alert">{formik.errors.cuisineId}</span>
                </div>
              )}
            </div>
            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Category
              </label>
              <Select
                className={clsx(
                  "",
                  {
                    "is-invalid":
                      formik.touched.categoryId && formik.errors.categoryId,
                  },
                  {
                    "is-valid":
                      formik.touched.categoryId && !formik.errors.categoryId,
                  }
                )}
                options={category.map((item) => ({
                  label: item.name,
                  value: item.uuid,
                }))}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSelectedCategory(selectedOption);
                    formik.setFieldValue("categoryId", selectedOption.value);
                  }
                }}
                value={selectedCategory}
                placeholder="Select category"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "20px", // Change the border radius as needed
                  }),
                }}
              />
            </div>
            {formik.touched.categoryId && formik.errors.categoryId && (
              <div className="fv-plugins-message-container">
                <span role="alert">{formik.errors.categoryId}</span>
              </div>
            )}
            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Type
              </label>
              <div className="row type-snippet">
                {type.map((item: any, i) => {
                  const isActive = activeType === item?.name;
                  return (
                    <div
                      className={`mt-1 snippet ${isActive ? "active" : ""}`}
                      key={i}
                      onClick={() => {
                        formik.setFieldValue("typeId", item?.uuid);
                        setActiveType(item?.name);
                        setSelectedType(isActive ? "" : item?.name);
                      }}
                    >
                      <span>
                        <img src={item?.icon} alt={item?.name} /> {item?.name}
                      </span>

                      <div className="ico">
                        <img
                          className={isActive ? "tick" : "cross"}
                          src={`/assets/images/${isActive ? "tick" : "cross"
                            }-circle-ico.svg`}
                          alt="ico"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              {formik.touched.typeId && formik.errors.typeId && (
                <div className="fv-plugins-message-container">
                  <span role="alert">{formik.errors.typeId}</span>
                </div>
              )}
            </div>

            <div className="row mb-12  mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Preparation Time
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="capitalize-text form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                  value={preparationTimeValue}
                  onChange={handlePreparationTimeChange} // Updated here
                  ref={(el) => {
                    inputs.current[3] = el;
                  }}
                />
                {formik.touched.preparationTime &&
                  formik.errors.preparationTime && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block text-danger">
                        {formik.errors.preparationTime}
                      </div>
                    </div>
                  )}
              </div>
              <div className="col-lg-6">
                <select
                  className="form-select form-select-solid form-select-lg"
                  value={preparationTypeValue}
                  onChange={handlePreparationTypeChange} // Updated here
                  ref={(el) => {
                    inputs.current[3] = el;
                  }}
                >
                  <option value="Mins">Mins</option>
                  <option value="Hours">Hours</option>
                </select>
              </div>
            </div>

            <div className="col-12 mb-3">
              {/* // Dish Price Division */}

              <div className="addon-wrap">
                {dishvariants.map((dish, index) => (
                  <div className="row gx-2 mb-2 position-relative" key={index}>
                    <div className="col-md-3 col-6">
                      <label
                        htmlFor=""
                        className="form-label me-3 d-flex align-items-center"
                      >
                        Measurement
                        <span className="mb-0 d-flex align-items-center opacity-40 mt-0">
                          <i
                            className="material-symbols-outlined info-ico me-2"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={`For Eg: 1.Size(Small, Medium, Large), 2. Piece (1,2,3), 3.Ounce (4,8,12,16)`}
                          >
                            info
                          </i>
                        </span>
                      </label>
                      <select
                        className="form-select form-control mb-2"
                        {...formik.getFieldProps(
                          `dishvariants[${index}].measurementId`
                        )}
                        onChange={(e) => {
                          formik.handleChange(e); // Ensure Formik handles the change event
                          handleMeasurementChange(e, index); // Handle custom logic for measurement change
                        }}
                      >
                        <option value="">Choose</option>
                        {filteredMeasurements.map(
                          (item: Measurement, id: number) => (
                            <option value={item?.id} key={id}>
                              {item?.measurementName}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <div className="col-md-2 col-6">
                      <label htmlFor="" className="form-label">
                        {/* {selectedMeasurementName || "Unit"} */}
                        Unit/Count
                      </label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="unit..."
                        ref={(el) => {
                          inputs.current[3] = el;
                        }}
                        {...formik.getFieldProps(`dishvariants[${index}].unit`)}
                      />
                      {formik.touched.dishvariants &&
                        formik.touched.dishvariants[index]?.unit &&
                        formik.errors.dishvariants &&
                        (formik.errors.dishvariants[index] as { unit?: string })
                          ?.unit && (
                          <div className="fv-plugins-message-container">
                            <span role="alert">
                              {
                                (
                                  formik.errors.dishvariants[index] as {
                                    unit?: string;
                                  }
                                )?.unit
                              }
                            </span>
                          </div>
                        )}
                    </div>

                    <div className="col-md-2 col-6">
                      <label htmlFor="" className="form-label">
                        Price ($)
                      </label>

                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="$ 00.00"
                        ref={(el) => {
                          inputs.current[3] = el;
                        }}
                        {...formik.getFieldProps(
                          `dishvariants[${index}].price`
                        )}
                        onChange={(e) => handlePriceChange(e, index)}
                      />
                      {formik.touched.dishvariants &&
                        formik.touched.dishvariants[index]?.price &&
                        formik.errors.dishvariants &&
                        (formik.errors.dishvariants as any[])[index]?.price && (
                          <div className="fv-plugins-message-container">
                            <span role="alert">
                              {
                                (formik.errors.dishvariants[index] as any)
                                  ?.price
                              }
                            </span>
                          </div>
                        )}
                    </div>
                    <div className="col-md-2 col-6">
                      <label htmlFor="" className="form-label">
                        Discount
                      </label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="$ 00.00"
                        ref={(el) => {
                          inputs.current[3] = el;
                        }}
                        {...formik.getFieldProps(
                          `dishvariants[${index}].discount`
                        )}
                        onChange={(e) => handleDiscountChange(e, index)}
                      />
                    </div>

                    <div className="col-md-3 col-12">
                      <label htmlFor="" className="form-label">
                        Final Price ($)
                      </label>
                      <input
                        type="text"
                        readOnly
                        className="form-control mb-2"
                        placeholder="$ 00.00"
                        ref={(el) => {
                          inputs.current[3] = el;
                        }}
                        {...formik.getFieldProps(
                          `dishvariants[${index}].finalPrice`
                        )}
                      />
                      {formik.touched.dishvariants &&
                        formik.touched.dishvariants[index]?.finalPrice &&
                        formik.errors.dishvariants &&
                        (formik.errors.dishvariants as any[])[index]
                          ?.finalPrice && (
                          <div className="fv-plugins-message-container">
                            <span role="alert">
                              {
                                (formik.errors.dishvariants[index] as any)
                                  ?.finalPrice
                              }
                            </span>
                          </div>
                        )}
                    </div>

                    <a
                      className="danger tiny cursorPointer mt-4"
                      onClick={() => DishPricRemove(index)}
                    >
                      <i className="material-symbols-outlined">delete</i>
                    </a>
                  </div>
                ))}
              </div>

              <p className="text-end mb-0">
                <a
                  className="text-link tiny cursorPointer"
                  onClick={addDishPriceRow}
                >
                  + Add New
                </a>
              </p>
              {/* addons Start */}
              <div className="row os-body">
                <div className="col-12">
                  <h6 className="mb-2">&nbsp;</h6>
                  <div
                    className="accordion bill-toggle px-0"
                    id="accordionExample"
                  >
                    {addonsType?.map((addonType, addonIndex) => {
                      // Determine if the accordion should be open initially
                      const isOpen = false; // Replace this with your condition if needed

                      return (
                        <div
                          className="accordion-item"
                          key={`addonType-${addonIndex}`}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            marginBottom: "10px",
                          }}
                        >
                          <h2
                            className="accordion-header"
                            id={`heading-${addonIndex}`}
                          >
                            <button
                              className={`accordion-button ${isOpen ? "" : "collapsed"
                                }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${addonIndex}`}
                              aria-expanded={isOpen}
                              aria-controls={`collapse-${addonIndex}`}
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "none",
                                borderRadius: "8px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              }}
                            >
                              <h6
                                className="mb-0"
                                style={{ fontSize: "16px", fontWeight: "600" }}
                              >
                                {addonType?.typeName}{" "}
                              </h6>
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  marginLeft: "5px",
                                }}
                              >
                                ({dishAddons.length})
                              </span>

                              <span
                                className="mt-3"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  marginLeft: "7px",
                                }}
                              >
                                <i
                                  className="material-symbols-outlined info-ico me-2"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={addonType?.description}
                                >
                                  info
                                </i>
                              </span>
                            </button>
                          </h2>
                          <div
                            id={`collapse-${addonIndex}`}
                            className={`accordion-collapse collapse ${isOpen ? "show" : ""
                              }`}
                            aria-labelledby={`heading-${addonIndex}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div
                              className="accordion-body"
                              style={{
                                padding: "15px",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              {dishAddons?.map((item, i) => (
                                <div
                                  className="row mb-3"
                                  key={i}
                                  style={{
                                    borderBottom: "1px solid #ddd",
                                    paddingBottom: "10px",
                                  }}
                                >
                                  <p className="col-5 mid-gray mb-0">
                                    <input
                                      type="checkbox"
                                      id={item.uuid}
                                      value={item.uuid}
                                      checked={(
                                        selectedAddons[addonType.uuid] || []
                                      ).includes(item.uuid)}
                                      onChange={() =>
                                        handleCheckboxChangeDishaddon(
                                          addonType.uuid,
                                          item.uuid
                                        )
                                      }
                                      style={{ marginRight: "10px" }}
                                    />
                                    <small className="px-2">
                                      {item?.addonsName}
                                    </small>
                                  </p>
                                  <h6
                                    className="col-4 mid-gray medium mb-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {item.type?.name}
                                  </h6>
                                  <h6
                                    className="col-3 mid-gray medium mb-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    $ {item.amount.toFixed(2)}
                                  </h6>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* end */}
            </div>

            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Tags (Optional)
              </label>
              <div className="strengths-tags mt-1 mb-1">
                {formik.values.tags &&
                  formik.values.tags.split(",").map((tag, index) => (
                    <span key={index} className="tag-wrapper">
                      <span className="tag-text">{tag.trim()}</span>
                      <button
                        type="button"
                        className="btn-close btn-sm btn-close-gray ms-2"
                        onClick={() => handleRemoveStrength(index)}
                        style={{ fontSize: "0.45rem" }}
                      ></button>
                    </span>
                  ))}
              </div>

              <input
                type="text"
                ref={(el) => {
                  inputs.current[3] = el;
                }}
                value={formik.values.tags}
                onChange={(e) => handleTagInputChange(e.target.value)}
                className={clsx(
                  "form-control h-auto",
                  {
                    "is-invalid": formik.touched.tags && formik.errors.tags,
                  },
                  {
                    "is-valid": formik.touched.tags && !formik.errors.tags,
                  }
                )}
              />
              <p className="text-success">
                <small>Separate using comma (,)</small>
              </p>
            </div>

            <div className="col-12 mb-3 row">
              <label className="form-label">Ingredients</label>
              <div className="d-flex align-items-center">
                <Select
                  isMulti={true}
                  className="col-12"
                  options={ingredient.map((item: any) => ({
                    label: item.name,
                    value: item.id.toString(),
                  }))}
                  name="ingredients"
                  placeholder="Select ingredient"
                  value={
                    formik.values.ingredients
                      ? formik.values.ingredients
                        .split(",")
                        .map((item: string) => ({
                          label: ingredient.find(
                            (i) => i.id.toString() === item
                          )?.name,
                          value: item,
                        }))
                      : []
                  }
                  onChange={(selectedOptions) => {
                    if (selectedOptions.length <= 30) {
                      const selectedValues = selectedOptions
                        .map((option) => option.value)
                        .join(",");
                      formik.setFieldValue("ingredients", selectedValues);
                    }
                  }}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderRadius: "20px",
                    }),
                  }}
                />

                <button
                  className="btn btn-outline-primary btn-sm rounded-4 mt-2 col-1 mb-2 ms-3 ingrd-add-btn"
                  style={{ width: "32px", height: "32px", padding: "0" }}
                  onClick={modalIngredient}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                <AddIngredient show={showIngredient} onHide={modalIngredient} />
              </div>
            </div>
            {formik.touched.ingredients && formik.errors.ingredients && (
              <div className="fv-plugins-message-container">
                <span role="alert">{formik.errors.ingredients}</span>
              </div>
            )}

            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Special Instruction (Optional)
              </label>
              <textarea
                className={clsx(
                  "form-control textarea",
                  {
                    "is-invalid":
                      formik.touched.specialInstruction &&
                      formik.errors.specialInstruction,
                  },
                  {
                    "is-valid":
                      formik.touched.specialInstruction &&
                      !formik.errors.specialInstruction,
                  }
                )}
                id=""
                cols={30}
                rows={10}
                placeholder="Give a special instruction for your dish..."
                {...formik.getFieldProps(`specialInstruction`)}
              ></textarea>
            </div>
            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label">
                Description (Optional)
              </label>
              <textarea
                className={clsx(
                  "form-control textarea",
                  {
                    "is-invalid":
                      formik.touched.description && formik.errors.description,
                  },
                  {
                    "is-valid":
                      formik.touched.description && !formik.errors.description,
                  }
                )}
                id=""
                cols={30}
                rows={10}
                placeholder="Give a description for your dish..."
                {...formik.getFieldProps(`description`)}
              ></textarea>
            </div>

            <div className="col-12 mt-3">
              <div className="row"></div>
            </div>


            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-12 text-end">
                  <button
                    className="btn btn-cancel rounded-5"
                    onClick={clickCancel}
                  >
                    Cancel
                  </button>

                  <button
                 

                    className="btn btn-outline-primary rounded-5 me-2"
                  >
                    {!loading && (
                      <span className="indicator-label">Publish</span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default AddDish;
